export const QUERY_KEY_CAMERA_SNAPSHOT_DEVICES = 'camera-snapshot-devices'
export const QUERY_KEY_CAMERA_PHOTO_STATS = 'camera-photo-stats'
export const QUERY_KEY_CAMERA_PREVIEWS = 'camera-previews'
